import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import { Handle } from 'react-flow-renderer';

import { LineLastSymbol, LineLastSymbolDark } from '../../assets/symbols';
import styles from './Diagram.module.scss';

const DeviceNode = React.memo(({ id, onDeleteNode, isConnectable }) => {
  const handleRemoveNodeClick = useCallback(() => {
    onDeleteNode(id);
  }, [id, onDeleteNode]);

  return (
    <div className={styles.customNode}>
      <Handle
        type="target"
        position="top"
        style={{ background: '#000' }}
        isConnectable={isConnectable}
        className={styles.handleTopLine}
      />
      <LineLastSymbol className={`white-block `} />
      <LineLastSymbolDark className={`dark-block `} />
      <Button
        type="button"
        className={styles.removeNodeButton}
        onClick={(event) => handleRemoveNodeClick(event, id)}
      >
        ×
      </Button>
    </div>
  );
});

DeviceNode.propTypes = {
  id: PropTypes.string,
  onDeleteNode: PropTypes.func.isRequired,
  isConnectable: PropTypes.bool,
};

DeviceNode.defaultProps = {
  id: undefined,
  isConnectable: undefined,
};

export default DeviceNode;
